// extracted by mini-css-extract-plugin
module.exports = {"header":"MainSliderCatalog_header__A60oS","tex":"MainSliderCatalog_tex__vSV6Y","wrapper":"MainSliderCatalog_wrapper__RMmMX"};